import PropTypes from 'prop-types';
import React from 'react';
import { Fragment } from 'react';

const CampaignQRCodeItem = (props) => {
  return <Fragment>{props.children}</Fragment>;
};

CampaignQRCodeItem.propTypes = {
  children: PropTypes.any
};

export default CampaignQRCodeItem;